import { render, staticRenderFns } from "./UpdateBrandsProductsDialog.vue?vue&type=template&id=48e46f75&scoped=true&"
import script from "./UpdateBrandsProductsDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateBrandsProductsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e46f75",
  null
  
)

export default component.exports